import React from 'react';

const SendButtonIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.48148 16L0 6.51852L16 0L9.48148 16ZM8.88889 13.037L12.9481 3.05185L2.96296 7.11111L5.03704 9.18519L9.48148 6.51852L6.81481 10.963L8.88889 13.037Z"
        fill="white"
      />
    </svg>
  );
};

export default SendButtonIcon;
